import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Box } from '@mui/material';

import Tooltip from './FormBuilderFormTooltip';
import { J, labelStyle } from '../FormBuilderFormStyles';

/**
 * Field — label + control wrapper.
 * @param {{
 *   label: string,
 *   tip?: string,
 *   children: React.ReactNode,
 *   sxc?: object,
 *   labelPos?: 'top'|'left',   // default 'top' — existing behavior unchanged
 *   labelWidth?: number|string, // only used when labelPos='left' — e.g. 100 or '100px'. Omit for auto width.
 * }} props
 */
export function Field({ label, tip, children, sxc, labelPos = 'top', labelWidth }) {
    const sx = sxc === undefined ? { marginBottom: 2, mr: '4px' } : { marginBottom: 2, ...sxc };

    const fontSize = 13;

    const labelEl = tip ? (
        <Tooltip tip={tip}>
            <span style={{ color: J.muted, fontSize: fontSize }}>{label}</span>
        </Tooltip>
    ) : (
        <span style={{ color: J.muted, fontSize: fontSize }}>{label}</span>
    );

    if (labelPos === 'left') {
        const widthPx = labelWidth !== undefined ? (typeof labelWidth === 'number' ? `${labelWidth}px` : labelWidth) : undefined;
        return (
            <Box sx={{ ...sx, display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ ...labelStyle, flexShrink: 0, width: widthPx }}>{labelEl}</span>
                <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
            </Box>
        );
    }

    return (
        <Box sx={sx}>
            <span style={labelStyle}>{labelEl}</span>
            {children}
        </Box>
    );
}

export function ColHeader({ label, tip }) {
    return tip ? (
        <Tooltip tip={tip}>
            <span style={{ color: J.muted, fontSize: 10 }}>{label}</span>
        </Tooltip>
    ) : (
        <span style={{ color: J.muted, fontSize: 10 }}>{label}</span>
    );
}

export function Toggle({ value, onLabel, offLabel, onClick }) {
    return (
        <div
            onClick={onClick}
            style={{
                color: value ? J.accent : J.muted,
                fontSize: 10,
                cursor: 'pointer',
                textAlign: 'center',
                userSelect: 'none',
            }}
        >
            {value ? onLabel : offLabel}
        </div>
    );
}
